// src/Components/Loader.js
import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-[9999]">
      <div className="relative w-32 h-32 flex items-center justify-center">
        {/* Outer Ring */}
        <div className="absolute w-full h-full border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

        {/* Middle Ring */}
        <div className="absolute w-24 h-24 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>

        {/* Inner Ring */}
        <div className="absolute w-16 h-16 border-4 border-pink-500 border-t-transparent rounded-full animate-spin"></div>

        {/* Logo */}
        <img
          className="w-18 h-12 mr-2 object-contain drop-shadow-lg"
          src={process.env.PUBLIC_URL + "/media/logo/idspay_circle_white.png"}
          alt="logo"
        />

        {/* Pulse effect */}
        <div className="absolute w-32 h-32 bg-blue-500 opacity-20 rounded-full animate-ping"></div>
      </div>
    </div>
  );
};

export default Loader;
